import { BASE_URL } from "../constants";
import api from "../middlware/api";

export const getVitals = () => {
  return api.get(`${BASE_URL}/api/v1/vitals`);
};
